import { connect } from 'react-redux';
import { ScanCardUploadView } from './ScanCardUploadView';
import { closeScanCard, closeDropdown } from '../../../data/dropdown-state/dropdownStateActions';
import { fetchScanCard, capturedFrontInsuranceCard, privacyCheckboxClicked, dismissPrivacyDialog } from '../ScanCardActions';
import { getScanCardState } from '../../../data/scan-card/scanCardSelector';


export function mapStateToProps(state) {
    const cardState = getScanCardState(state);

    return {
        ...cardState,
    };
}

export const mapDispatchToProps = {
    closeScanCard,
    closeDropdown,
    fetchScanCard,
    capturedFrontInsuranceCard,
    privacyCheckboxClicked,
    dismissPrivacyDialog,
};

export const ScanCardUploadConnector = connect(
    mapStateToProps,
    mapDispatchToProps
)(ScanCardUploadView);
